// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ZG0qmn83xKaAzJt4KWrXW","sleek_spinner":"SpNz2hoaMKAJHtAJW_U_R"};